(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "animejs", "../_style/images/inlineLoadingGif", "../transition"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("animejs"), require("../_style/images/inlineLoadingGif"), require("../transition"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.animejs, global.inlineLoadingGif, global.transition);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _animejs, _inlineLoadingGif, _transition) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _animejs = _interopRequireDefault(_animejs);
  _transition = _interopRequireDefault(_transition);

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('nx-transition', {
        attrs: {
          "name": "nx-switch-loading-fade",
          "mode": "out-in"
        }
      }, [_vm.status !== 'loading' ? _c('div', {
        key: "switch",
        staticClass: "nx-switch",
        class: _vm.disabled ? 'nx-switch-disable' : '',
        attrs: {
          "tabindex": "-1",
          "aria-checked": !!_vm.value,
          "aria-disabled": _vm.disabled,
          "role": "switch"
        },
        on: {
          "click": _vm.onClick
        }
      }, [_c('div', {
        style: _vm.barStyle
      }), _c('div', {
        style: _vm.ringStyle
      })]) : _vm._e(), _vm.status === 'loading' ? _c('div', {
        key: "loading",
        staticClass: "nx-switch nx-switch-flex-center"
      }, [_c('img', {
        staticClass: "nx-switch-loading",
        attrs: {
          "src": _vm.loadingSrc,
          "role": "option",
          "aria-label": "开关，加载中",
          "tabindex": "-1"
        }
      })]) : _vm._e()]);
    },
    name: 'nx-switch',
    components: (0, _defineProperty2.default)({}, _transition.default.name, _transition.default),
    props: {
      value: {
        default: false
      },
      status: {
        type: String,
        default: ''
      },
      disabled: Boolean,
      activeColor: {
        type: String,
        default: 'rgba(176, 194, 255, 1)'
      },
      activeColorDark: {
        type: String,
        default: 'rgba(69, 111, 255, 0.4)'
      },
      inactiveColor: {
        type: String,
        default: 'rgba(255, 255, 255, 1)'
      },
      inactiveColorDark: {
        type: String,
        default: 'rgba(0, 0, 0, 1)'
      },
      duration: {
        type: Number,
        default: 250
      },
      circleColor: {
        type: String,
        default: '#415fff'
      },
      circleColorDark: {
        type: String,
        default: '#415fff'
      },
      circleBgColor: {
        type: String,
        default: 'rgba(255, 255, 255, 0.9)'
      },
      circleBgColorDark: {
        type: String,
        default: 'rgba(0, 0, 0, 1)'
      }
    },
    data: function data() {
      return {
        nxSwitch: {
          path: '',
          circleTranslate: 0
        },
        loadingSrc: _inlineLoadingGif.inlineLoadingGifS,
        isDark: window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      };
    },
    computed: {
      ringStyle: function ringStyle() {
        return {
          position: 'absolute',
          boxSizing: 'content-box',
          left: this.value ? '17px' : '0px',
          top: this.value ? '0px' : '2px',
          width: this.value ? '17px' : '14px',
          height: this.value ? '17px' : '14px',
          borderRadius: '50%',
          border: this.value ? "3.2px solid ".concat(this.isDark ? this.circleColorDark : this.circleColor) : "3px solid  ".concat(this.isDark ? '#464646' : '#CCCCCC'),
          backgroundColor: this.isDark ? this.circleBgColorDark : this.circleBgColor,
          transitionDuration: "".concat(this.duration, "ms")
        };
      },
      barStyle: function barStyle() {
        return {
          position: 'absolute',
          left: '0px',
          top: this.value ? '5px' : '2px',
          width: this.value ? '40px' : '35px',
          height: this.value ? '13px' : '15px',
          background: this.value ? this.isDark ? this.activeColorDark : this.activeColor : this.isDark ? this.inactiveColorDark : this.inactiveColor,
          border: this.value ? '' : "2.5px solid ".concat(this.isDark ? 'rgba(70, 70, 70, 0.46)' : 'rgba(204,204,204, 0.36)'),
          borderRadius: this.value ? '6.5px' : '10px',
          transitionDuration: '0.1s',
          boxSizing: 'content-box'
        };
      }
    },
    watch: {
      value: function value(_value) {
        this.$emit('change', _value);
        this.animationPlayed && this.animation.reverse();
        this.animation.play();
        this.animationPlayed = true;
      },
      duration: function duration() {
        this.switchReset();
      }
    },
    created: function created() {
      // 判断深色模式
      var nxThemeOff = document.documentElement && document.documentElement.getAttribute('data-nx-theme') === 'off';
      this.isDark = !nxThemeOff && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches; // 初始化

      this.switchReset(); // 提前加载loading动效

      var i = new Image();
      i.src = _inlineLoadingGif.inlineLoadingGifS;
    },
    methods: {
      onClick: function onClick(event) {
        if (this.disabled) {
          return;
        }

        this.$emit('input', !this.value);
        this.$emit('click', event);
      },
      switchReset: function switchReset() {
        var _this = this;

        var state = this.value ? 'on' : 'off';
        var targetState = state === 'on' ? 'off' : 'on';

        var switchState = _objectSpread({}, this.nxSwitch[state]);

        var switchTargetState = _objectSpread({}, this.nxSwitch[targetState]);

        this.nxSwitch = _objectSpread({}, switchState);
        this.animationPlayed = false;
        this.animation && this.animation.pause();
        this.animation = (0, _animejs.default)({
          targets: switchState,
          path: switchTargetState.path,
          circleTranslate: switchTargetState.circleTranslate,
          autoplay: false,
          duration: this.duration,
          easing: 'easeInOutSine',
          update: function update(anime) {
            anime.animations.forEach(function (_ref) {
              var property = _ref.property,
                  currentValue = _ref.currentValue;
              var attr = ['path', 'circleTranslate'];

              if (attr.indexOf(property) > -1) {
                _this.nxSwitch[property] = currentValue;
              }
            });
          }
        });
      }
    }
  };
  _exports.default = _default;
});